import React from 'react';
import { Button } from '../components/ui/button';
import { MapPin, RefreshCw } from 'lucide-react';

/**
 * Location Required Screen
 * Shows when user denies location permission
 * Blocks app access until location is granted
 */
const LocationRequired = ({ onRetry }) => {
  const getBrowserInstructions = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    
    if (userAgent.includes('chrome')) {
      return '1. Click the lock icon in the address bar\n2. Find "Location" and set to "Allow"\n3. Reload the page';
    } else if (userAgent.includes('firefox')) {
      return '1. Click the lock icon in the address bar\n2. Click "Permissions"\n3. Find "Access Your Location" and choose "Allow"\n4. Reload the page';
    } else if (userAgent.includes('safari')) {
      return '1. Safari → Settings\n2. Websites → Location\n3. Find this site and set to "Allow"\n4. Reload the page';
    } else {
      return '1. Check your browser settings\n2. Allow location access for this site\n3. Reload the page';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-500 via-pink-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center">
            <MapPin className="w-10 h-10 text-purple-600" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-center text-gray-900 mb-3">
          Location Required
        </h1>

        {/* Message */}
        <p className="text-center text-gray-600 mb-6">
          Swyper shows you matches near you, so we need your location to work. 
          Your exact location is never shared – only approximate distance between users.
        </p>

        {/* Browser Instructions */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <h3 className="text-sm font-semibold text-gray-900 mb-2">
            How to enable location:
          </h3>
          <pre className="text-xs text-gray-700 whitespace-pre-wrap font-sans">
            {getBrowserInstructions()}
          </pre>
        </div>

        {/* Try Again Button */}
        <Button
          onClick={onRetry}
          className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-6 text-lg"
        >
          <RefreshCw className="w-5 h-5 mr-2" />
          Try Again
        </Button>

        {/* Footer Note */}
        <p className="text-xs text-center text-gray-500 mt-6">
          By using Swyper, you agree to share your location for matching purposes as stated in our Terms of Service.
        </p>
      </div>
    </div>
  );
};

export default LocationRequired;
